// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadDocumentRequestModel from '../../model/download-document-request-model';
import DownloadDocumentRequestDTO from '../dto/download-document-request-dto';
import dtoSchema from '../schemas/download-document-request-schema';

export default abstract class DownloadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadDocumentRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO>): DownloadDocumentRequestModel;
  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO> | undefined | null): DownloadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO> | undefined | null): DownloadDocumentRequestModel | undefined {
    return dto ? new DownloadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadDocumentRequestModel> | DownloadDocumentRequestModel): DownloadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as DownloadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadDocumentRequestModel, can not map to DownloadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
